import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Spacer from 'components/ui/Spacer';
import { LinkProject } from 'components/landlord_app/purchase_orders/components/LinkProject';

import { getTranslatedString } from 'helpers/i18n';

import { getProperties, getUnits } from 'actions/landlordPropertiesActions';
import { postProject } from 'components/landlord_app/maintenance/projects/store/actions';

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const LinkToProject = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  properties,
  linkedProject,
  getProperties,
  units,
  postProject,
}) => {
  const [selectedProject, setSelectedProject] = useState(linkedProject);

  const handlePropertyChange = value => {
    setFieldValue('property_id', value);
    getUnits(value, { for_multiselect: true });
  };

  const handleSelectProject = (projectID, project) => {
    setFieldValue('project_id', projectID);
    setSelectedProject(project);
  };

  const handleUnlinkProject = projectID => {
    setFieldValue('project_id', '');
    setSelectedProject(null);
  };

  return (
    <React.Fragment>
      <Spacer mb={0.3}>
        <FormTitle>{getTranslatedString('landlordPortal.linkProject.linkToProject')}</FormTitle>
      </Spacer>
      <LinkProject
        handleSelectProject={handleSelectProject}
        handleUnlinkProject={handleUnlinkProject}
        selectedProject={selectedProject}
        propertyId={values.property_id}
        properties={properties}
        units={units}
        postProject={postProject}
        fetchUnitsOfProperty={handlePropertyChange}
        showTitle={false}
        padding="0"
      />
    </React.Fragment>
  );
};

const mapStoreToProps = store => {
  return {
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
  };
};

const mapDispatchToProps = {
  getUnits,
  getProperties,
  postProject,
};

export default connect(mapStoreToProps, mapDispatchToProps)(LinkToProject);
